/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiEventAction
 */
export interface ApiEventAction {
  /**
   *
   * @type {string}
   * @memberof ApiEventAction
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiEventAction
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof ApiEventAction
   */
  action: ApiEventActionActionEnum;
  /**
   *
   * @type {string}
   * @memberof ApiEventAction
   */
  label: string;
}

/**
 * @export
 */
export const ApiEventActionActionEnum = {
  Impression: 'impression',
  Click: 'click',
  ClickTextInput: 'click / text input',
  Add: 'add',
  Remove: 'remove',
  Error: 'error',
} as const;
export type ApiEventActionActionEnum = typeof ApiEventActionActionEnum[keyof typeof ApiEventActionActionEnum];

export function ApiEventActionFromJSON(json: any): ApiEventAction {
  return ApiEventActionFromJSONTyped(json, false);
}

export function ApiEventActionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiEventAction {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json['name'],
    category: json['category'],
    action: json['action'],
    label: json['label'],
  };
}

export function ApiEventActionToJSON(value?: ApiEventAction | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    category: value.category,
    action: value.action,
    label: value.label,
  };
}
